/**
 * 앱 아이콘 배지 모듈
 *
 * 홈 화면 앱 아이콘에 숫자 배지(뱃지)를 표시하거나 제거합니다.
 * (예: 읽지 않은 알림 개수 표시)
 *
 * @capawesome/capacitor-badge 패키지를 사용합니다.
 * 웹 환경에서는 아무 동작 없이 안전하게 무시됩니다.
 * (추후 UI 연결 예정)
 */

import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';

/**
 * 앱 아이콘 배지에 숫자를 설정합니다.
 * @param {number} count - 표시할 숫자 (0이면 배지 제거)
 */
export async function setBadgeCount(count) {
  if (!Capacitor.isNativePlatform()) return;

  try {
    if (count <= 0) {
      await Badge.clear();
    } else {
      await Badge.set({ count });
    }
  } catch (err) {
    console.warn('[배지] setBadgeCount 실패:', err);
  }
}

/**
 * 앱 아이콘 배지를 제거합니다.
 */
export async function clearBadge() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await Badge.clear();
  } catch (err) {
    console.warn('[배지] clearBadge 실패:', err);
  }
}

/**
 * 현재 배지 숫자를 가져옵니다.
 * @returns {Promise<number>} 현재 배지 숫자 (없으면 0)
 */
export async function getBadgeCount() {
  if (!Capacitor.isNativePlatform()) return 0;

  try {
    const { count } = await Badge.get();
    return count;
  } catch (err) {
    console.warn('[배지] getBadgeCount 실패:', err);
    return 0;
  }
}
